import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Outlet } from "react-router-dom"; // To dynamically load content
import "../styles/GoogleBar.css";

const GoogleBar = () => {
  const navigate = useNavigate();

  // Rotating title text
  const titles = ["Software Engineer", "Full Stack Developer", "Problem Solver"];
  const [currentTitle, setCurrentTitle] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTitle((prev) => (prev + 1) % titles.length);
    }, 2000); // Rotate every 2 seconds
    return () => clearInterval(interval);
  }, [titles.length]);

  return (
    <>
      <div className="google-bar">
        {/* Google Logo & Search Bar in One Line */}
        <div className="logo-search">
          {/* Google Logo */}
          <h1 className="google-logo">
            {["W", "E", "L", "C", "O", "M", "E"].map((letter, index) => (
              <span key={index} className={`letter letter-${index}`}>
                {letter}
              </span>
            ))}
          </h1>

          {/* Search Bar */}
          <div className="search-wrapper">
            <input
              type="text"
              className="search-input"
              placeholder="Search Google or type a URL"
            />
            <button type="submit" className="search-icon">🔍</button>
          </div>
        </div>

        {/* Navigation Buttons Below Search Bar */}
        <div className="google-links">
          <button 
            className={`tab-button ${window.location.pathname === "/overview" ? "active" : ""}`}
            onClick={() => navigate("/overview")}
          >
            Overview
          </button>
          {/* <button 
            className={`tab-button ${window.location.pathname === "/stats" ? "active" : ""}`}
            onClick={() => navigate("/stats")}
          >
            Stats
          </button> */}
        </div>

        {/* Name & Animated Title */}
        <div className="profile-container">
          <h1 className="profile-title">Srijan Sareen</h1>
          <p className="profile-subtitle animated-title">{titles[currentTitle]}</p>
        </div>
      </div>

      {/* Render the selected page below the GoogleBar */}
      <Outlet />
    </>
  );
};

export default GoogleBar;
